import React from "react";
import ItemSpacer from "../ItemSpacer";

const InfoItemLabelList = (props: { children: React.ReactNode }) => {
  return <ItemSpacer gap={15}>{props.children}</ItemSpacer>;
};

export default InfoItemLabelList;
